import { Outlet } from "react-router-dom";

const ExpensesParentPage = () => {
    return <Outlet />
}

export default ExpensesParentPage;